// extracted by mini-css-extract-plugin
export default {"custom_loader":"loader_custom_loader__DNXmo","s2":"loader_s2__xE2LO","full_loader":"loader_full_loader__c6cXt"};